import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

/** The contract's name still opens the contract, as the row's own link did. */
export const titleLinkSx: SxProps<Theme> = {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
        textDecoration: 'underline',
    },
};
